module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "element element-non-bodymatter element-container-single element-type-epigraph element-without-heading",
    attrs: {
      "epub:type": "epigraph",
      "id": "epigraph-2"
    }
  }, [_c('div', {
    staticClass: "text",
    attrs: {
      "id": "epigraph-2-text"
    }
  }, [_c('p', {
    staticClass: "first first-in-chapter first-full-width"
  }, [_vm._v("This was written for an anthology, "), _c('i', [_vm._v("Slasher Girls and Monster Boys")]), _vm._v(" (Dial Books, 2015). It deals with body positivity and bullying issues—apart from zombies. I taught Women’s Self-Defense to thousands of students over the years and saw so many wonderful instances of someone who had been bullied or abused rising to claim their power and take agency over their lives. This story reflects a good deal of that. Though, admittedly, I never taught a class on self-defense against the living dead.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-29f7c77c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/authors-note-2.vue
// module id = 87
// module chunks = 0